import React from 'react'
import { isNumber } from 'lodash'

import { Panel, ButtonGroup, Table, ControlLabel, Tooltip, OverlayTrigger } from 'react-bootstrap'
import Button from '../components/Button'
import { getText, getTextWithTokens } from '../lib/text.js'
import { getEmptyPayment } from '../ducks/trips'
import { printMoney, randstr } from '../../lib/Tools'
import { getPaidTotals, getTripCode } from '../../lib/TripTools'
import PaymentModal from './PaymentModal'
import CreatePaymentModal from './CreatePaymentModal'

function nameGenerator(trip : Object): string {
  if (trip.tags.SPOT) {
    return `Pago ${trip.payments.length + 1}`
  }
  else if (trip.payments.length == 0) {
    return `Fianza`
  }
  else return `Pago ${trip.payments.length}`
}

function greenCheck() {
  return <div style={{ color: 'green', fontSize: 24 }}>✓</div>
}

function greyCheck() {
  return <div style={{ color: 'grey', fontSize: 24 }}>✓</div>
}

function tooltip() {
  return (
    <Tooltip id="tooltip">
      Click para ver enlace de pago
    </Tooltip>
  )
}

function paymentDates(payment) {
  return (
    <div
      style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}
    >
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
      ⏳
        {payment.sentDate}
      </div>
      {payment.isCarrierReceived && (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          {greenCheck()}
          <div style={{ marginLeft: '-12px' }}>{greyCheck()}</div>
          {payment.receivedCarrierDate}</div>
      )}
      {payment.isReceived && (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          {greenCheck()}
          {payment.isCarrierReceived && <div style={{ marginLeft: '-12px' }}>{greenCheck()}</div>}
          {payment.receivedDate}
        </div>
      )}
    </div>)
}

/**
 *
 */

type Props = {
  onChange: (Object[] => void),
  trip: Object,
  tripPrice: Object
}

export default class PaymentsList extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { editingIdx: null, creating : false, paymentAmount: null }
  }

  props: Props

  closeModal() { this.setState({ editingIdx: null, creating: false, paymentLink: false }) }

  render() {
    const { trip, onChange, tripPrice } = this.props

    const columns = [
      { key: "name",          money: false, label: getText("Nombre")                 },
      // { key: "sentDate",      money: false, label: getText("Fecha de transferencia") },
      { key: "paymentMethod", money: false, label: getText("Método de pago")         },
      { key: "eur",           money: true,  label: getText("€")                      },
      { key: "yuan",          money: true,  label: getText("¥")                      },
      { key: "receivedDate",  money: false, label: getText("Pago recibido")          },
      { key: "receivedEur",   money: true,  label: getText("Recibido (€)")           },
      { key: "comment",       money: false, label: getText("Comentario")             },
    ]

    const totals = getPaidTotals(trip)
    const code = getTripCode(trip)

    return (
      <div>
        <Panel className="main">
          <Panel.Body>
            <Table bordered striped>
              <thead>
                <tr>
                  <th />
                  {
                    columns.map(c => <th key={c.key}>{c.label}</th>)
                  }
                </tr>
              </thead>
              <tbody>
                {
                  trip.payments.length == 0
                    ? (<td colSpan={columns.length + 1} style={{ fontStyle: "italic" }}>{getText("no_payments")}</td>)
                    : (
                      trip.payments.map((payment, i) => (
                        <tr key={payment.key}>
                          <td>
                            <ButtonGroup>
                              <Button
                                bsSize="xsmall"
                                style={{ color: "red" }}
                                glyph="remove"
                                onClick={() => {
                                  if (confirm(getTextWithTokens("delete_payment", [payment.name]))) onChange(trip.payments.filter((item, j) => j != i))
                                }}
                              />
                              <Button
                                bsSize="xsmall"
                                glyph="pencil"
                                onClick={() => this.setState({ editingIdx: i })}
                              >
                                {getText("editButton")}
                              </Button>
                            </ButtonGroup>
                          </td>
                          {
                            columns.map(c => (
                              <td key={c.key} style={{ textAlign: "center" }}>
                                {
                                  (() => {
                                    if (c.key == "receivedDate") {
                                      return paymentDates(payment)
                                    }
                                    else if (c.key == "receivedEur") if (payment.isReceived) return printMoney(payment[c.key])
                                    else return `...`
                                    else if (c.key == "paymentMethod") {
                                      if (payment[c.key] == "tripmaker" && !payment.isCarrierReceived) return (
                                        <div>{getText(`method_${payment[c.key]}`)}
                                          <OverlayTrigger
                                            placement="top"
                                            overlay={tooltip()}
                                          >
                                            <Button
                                              bsSize="xsmall"
                                              bsStyle={this.state.copiedPayment == payment.key ? 'primary' : 'default'}
                                              style={{ marginLeft: 5 }}
                                              onClick={() => this.setState({ paymentLink: payment })}
                                            >
                                              🔗
                                            </Button>
                                          </OverlayTrigger>
                                        </div>
                                      )
                                      else return payment[c.key] ? getText(`method_${payment[c.key]}`) : "???"
                                    }
                                    else if (c.money) return printMoney(payment[c.key])
                                    else return payment[c.key]
                                  })()
                                }
                              </td>
                            ))
                          }
                        </tr>
                      ))
                    )
                }

                {
                  trip.payments.length != 0 && (
                    <tr>
                      <td style={{ textAlign: "center", fontWeight: "bold" }}>
                        {getText("Total")}
                      </td>
                      <td />
                      <td />
                      <td />
                      <td style={{ textAlign: "center", fontWeight: "bold" }}>
                        {printMoney(totals.eur)}
                      </td>
                      <td style={{ textAlign: "center", fontWeight: "bold" }}>
                        {printMoney(totals.yuan)}
                      </td>
                      <td />
                      <td style={{ textAlign: "center", fontWeight: "bold" }}>
                        {printMoney(totals.receivedEur)}
                      </td>
                      <td />
                    </tr>
                  )
                }

              </tbody>
            </Table>

            {/* #TODO: dont mix payment-creation logic in the view (belongs in the reducer) */ }

            <Button
              glyph={"plus"}
              onClick={() => {
                this.setState({ creating : true })
              }}
            >
              {getText("Nuevo pago")}
            </Button>

            <div
              style={{
                display: "inline-block",
                marginLeft: 30,
                borderWidth: 1,
                borderStyle: "solid",
                borderColor: "darkgrey",
                padding: 5,
                borderRadius: 5
              }}
            >
              <div style={{ margin: "auto" }}>
                <ControlLabel>{getText("Código para pagos")}:</ControlLabel>
                <code style={{ marginLeft: 10, fontSize: 16, fontWeight: 600, color: "black" }}>{code}</code>
              </div>
            </div>
          </Panel.Body>
        </Panel>

        <Table style={{ width: 300 }} striped bordered>
          <thead>
            <tr>
              <th />
              <th style={{ textAlign: "center" }}>€</th>
              <th style={{ textAlign: "center" }}>¥</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{getText("Coste presupuestado")}</td>
              <td style={{ color: tripPrice.finalE < 0 ? "red" : "black", fontWeight: "bold" }}>{printMoney(tripPrice.finalE)}€</td>
              <td style={{ color: tripPrice.finalY < 0 ? "red" : "black", fontStyle: "italic" }}>{printMoney(tripPrice.finalY)}¥</td>
            </tr>
            <tr>
              <td>{getText("Total pagado")}</td>
              <td style={{ color: totals.eur < 0 ? "red" : "black", fontWeight: "bold" }}>{printMoney(totals.eur)}€</td>
              <td style={{ color: totals.yuan < 0 ? "red" : "black" }}>{printMoney(totals.yuan)}¥</td>
            </tr>
            <tr>
              <td>{getText("Recibido")}</td>
              <td style={{ color: totals.receivedEur < 0 ? "red" : "black", fontWeight: "bold" }}>{printMoney(totals.receivedEur)}€</td>
              <td style={{ color: totals.receivedYuan < 0 ? "red" : "black", fontStyle: "italic" }}>{printMoney(totals.receivedYuan)}¥</td>
            </tr>
            <tr>
              <td>{getText("Falta por pagar")}</td>
              <td style={{ color: (tripPrice.finalE - totals.eur)  <= 0 ? "green" : "red", fontWeight: "bold" }}>{printMoney(tripPrice.finalE - totals.eur) }€</td>
              <td style={{ color: (tripPrice.finalY - totals.yuan) <= 0 ? "green" : "red", fontStyle: "italic" }}>{printMoney(tripPrice.finalY - totals.yuan)}¥</td>
            </tr>
          </tbody>
        </Table>

        {
          this.state.paymentLink && (
            <CreatePaymentModal
              tripId={trip._id}
              payment={this.state.paymentLink}
              onCancel={() => this.closeModal() }
            />
          )
        }

        {
          (isNumber(this.state.editingIdx) || this.state.creating) && (
            <PaymentModal
              isNewPayment={this.state.creating}
              payment={
                this.state.creating
                  ? { ...getEmptyPayment(), name: nameGenerator(this.props.trip), key: randstr() }
                  : trip.payments[this.state.editingIdx]
              }
              onChange={newPayment => {
                if (this.state.creating) {
                  onChange([...trip.payments, newPayment])
                  this.closeModal()
                  if (newPayment.paymentMethod == "tripmaker") this.setState({ paymentLink: newPayment })
                }
                else {
                  onChange(trip.payments.map((p, i) => (i == this.state.editingIdx ? newPayment : p)))
                  this.closeModal()
                }
              }}
              onCancel={() => this.closeModal() }
            />
          )
        }
      </div>
    )
  }
}
